// extracted by mini-css-extract-plugin
export default {"canvas":"hex_tiles_canvas__O0vDS","fixed":"hex_tiles_fixed__wcs9B","hexfixed":"hex_tiles_hexfixed__H2DOB","hexbg":"hex_tiles_hexbg__kZRr+"};